import React from 'react'
import { Box, Divider, Grid, Typography, Skeleton } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

import { WithLoading } from '../../../../../../../../components'

const useStyles = makeStyles(({ spacing, typography, palette }) => {
  const clamp = lines => ({
    lineClamp: lines,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical'
  })

  return {
    image: {
      width: 53,
      maxWidth: 53,
      height: 40,
      maxHeight: 40,
      borderRadius: 6
    },
    text: {
      flex: '1 1 0'
    },
    title: {
      ...typography.body.m,
      fontWeight: typography.fontWeightMedium,
      color: palette.grey.shade[90],
      ...clamp(1)
    },
    subtitle: {
      ...typography.body.s,
      fontWeight: typography.fontWeightMedium,
      color: palette.grey.shade[70],
      ...clamp(1)
    },
    divider: {
      marginTop: spacing(2)
    }
  }
})

const ArticleCard = props => {
  const classes = useStyles()
  const {
    article: { title, subtitle, image: { imgUrl, altText } = {} },
    'data-test': testAttr,
    onSelect
  } = props

  const handleClick = () => onSelect(props.article)

  return (
    <Grid
      container
      direction='row'
      wrap='nowrap'
      spacing={2}
      onClick={handleClick}
      data-test={testAttr}
    >
      <Grid item>
        <WithLoading loading={!imgUrl}>
          <img
            data-test={`${testAttr}-image`}
            className={classes.image}
            src={`${imgUrl}fit=crop&w=327&h=184`}
            alt={altText}
          />
        </WithLoading>
      </Grid>
      <Grid item className={classes.text}>
        <Box width='100%'>
          <Typography data-test={`${testAttr}-title`} className={classes.title}>
            {title || <Skeleton width='60%' />}
          </Typography>
          <Typography
            data-test={`${testAttr}-subtitle`}
            className={classes.subtitle}
          >
            {subtitle?.html || <Skeleton width='75%' />}
          </Typography>
          <Divider className={classes.divider} />
        </Box>
      </Grid>
    </Grid>
  )
}

export default ArticleCard
